import Request from "../../../../../api/Requests";

const getEventDetails = (params) => {
  return Request("events/info-form", "GET", params, true);
};

const getTicketsTransactions = (params) => {
  return Request("admin/event-list-tickets-transactions", "GET", params, true);
};

const getTablesTransactions = (params) => {
  return Request("events/list-transactions-event-tables", "GET", params, true);
};

const postponeEvent = (params) => {
  return Request("admin/event-postpone", "POST", params, true);
};

const cancelEvent = (params) => {
  return Request("admin/event-cancel", "POST", params, true);
};

const sendGeneralNotification = (params) => {
  return Request("admin/event-send-notification", "POST", params, true);
};

const refundAllTransactions = (params) => {
  return Request("admin/event-refund-all", "POST", params, true);
};

const refundSingleTransaction = (params) => {
  return Request("admin/transaction-refund", "POST", params, true);
};

export default {
  getEventDetails,
  getTicketsTransactions,
  getTablesTransactions,
  postponeEvent,
  cancelEvent,
  sendGeneralNotification,
  refundAllTransactions,
  refundSingleTransaction,
};
